import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Slider from 'react-slick';
import styled from 'styled-components';

export const StyledHeading = styled.h2`
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-size: ${({ theme }) => theme.fonts.sizes.subTitle};
  line-height: normal;
  text-align: center;
  color: ${({ theme }) => theme.colors.text.main};
  font-weight: ${({ theme }) => theme.fonts.weight.semiBold};
  margin: 0;


  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    font-size: 2.8rem;
  }

  @media (max-width: ${({ theme }) => theme.sizes.sm}) {
    font-size: 2.4rem;
  }
`;

export const StyledDescription = styled.p`
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-size: 2rem;
  line-height: normal;
  text-align: center;
  color: ${({ theme }) => theme.colors.grey[400]};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  max-width: 58.7rem;
  margin: 0;
  padding: 0 2rem;

  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    font-size: ${({ theme }) => theme.fonts.sizes.medium};
    width: 100%;
    max-width: none;
    padding: 0 3.2rem;
  }

  @media (max-width: ${({ theme }) => theme.sizes.sm}) {
    font-size: ${({ theme }) => theme.fonts.sizes.default};
    padding: 0 2.4rem;
  }
`;

export const StyledSectionWrapper = styled.section`
 padding: 11rem 0;
 margin-bottom: 20rem;
 background: rgba(24, 32, 49, 1);
 @media (max-width: ${({ theme }) => theme.sizes.md}) {
  padding: 3.4rem 1.8rem;
 }
`;

export const StyledHeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  margin: 0 1.8rem 4.6rem;

  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    gap: 1.6rem;
  }
`;

export const StyledCardsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 2.4rem;
  min-width: 27.8rem;
  min-height: 40.7rem;
  justify-content: center;

  @media (max-width: ${({ theme }) => theme.sizes.lg}) {
    gap: 3.2rem;
  }

  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    gap: 2.4rem;
  }
`;

export const StyledCard = styled.div`
  box-sizing: border-box !important;
  display: flex;
  flex-direction: column;
  gap: 1.8rem;
  padding: 3.2rem;
  background: ${({ theme }) => theme.colors.secondary.light};
  border-radius: 0.5rem;
  width: 46.4rem;
  height: 55rem;
  min-width: 44rem;

  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    padding: 2.4rem;
    gap: 1.6rem;
    width: auto;
  }
`;

export const StyledCardImage = styled.img`
  width: 70%;
  height: auto;
  margin-top: auto;
  margin-left: auto;
  margin-right: auto;
  object-fit: contain;
  display: block;
  flex-shrink: 0;
`;

export const StyledCardTitle = styled.h3`
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-size: 2.4rem;
  font-weight: 600;
  line-height: normal;
  color: ${({ theme }) => theme.colors.text.main};
  margin: 0 0 1.6rem 0;
    @media (max-width: ${({ theme }) => theme.sizes.md}) {
   font-size: 1.6rem;
  }
`;

export const StyledCardDescription = styled.p`
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-size: 1.8rem;
  line-height: normal;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.grey[400]};
  margin: 0;
  margin-bottom: 4.6rem;
  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    font-size: 1.6rem;
  }
`;

export const StyledIcon = styled(FontAwesomeIcon)`
 font-size:1.8rem;
  color: #719CF9;
  margin-bottom: 1.8rem;
  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    font-size: 1.6rem;
  }
`;

export const StyledSlider = styled(Slider)`
  width: 100%;

  .slick-slide > div {
    width: 46.4rem;
    
  }

   .slick-slide {
    width: 100% !important;
    height: 55rem !important;
    transition: all 0.3s ease;
  }

  .slick-track {
    display: flex !important;
    gap: 2.4rem;
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    .slick-track {
      margin-left: auto !important;
      margin-right: auto !important;
      align-items: center;
      justify-content: center;
    }
    .slick-track {
      gap: 1.2rem;
    }

    .slick-slide > div {
      width: 100%;
    }
  }

   @media screen and (min-width: ${({ theme }) => theme.sizes.md}) and (max-width: ${({ theme }) => theme.sizes.lg}) {
    width: 100%;

    .slick-track {
      display: flex !important;
      gap: 2.4rem;
      margin: 0 auto !important;
    }

  } 

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {

    position: relative;
    width: 100vw;
    margin-left: calc(-50vw + 49.5%);
  }
`;

export const StyledFadingEdges = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;

  .slick-list {
    overflow: hidden; /* Hide overflow by default for mobile/tablet */
  }

  @media (min-width: ${({ theme }) => theme.sizes.md}) {
    .slick-list {
      overflow: visible; /* Only show overflow for desktop where we want fading edges */
    }
    width: 100vw;
    margin-left: calc(-50vw + 49.5%);
    position: relative;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 20%;
      z-index: 1;
      background: linear-gradient(88deg, #182031 41.89%, rgba(24, 32, 49, 0.50) 69.87%, rgba(24, 32, 49, 0.00) 96.03%);
    }

    &::after {
      content: '';
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
      width: 20%;
      z-index: 1;
      background: linear-gradient(268deg, #182031 41.89%, rgba(24, 32, 49, 0.50) 69.87%, rgba(24, 32, 49, 0.00) 96.03%);
    }
  }
`;
